import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  BidsSimpleQuery,
  PaginationOptions,
  SearchBidsRequest,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../../useGraphQlClient";

const BIDS_QUERY = graphql(`
  query bidsSimple($request: SearchBidsRequest!, $pagination: PaginationOptions!) {
    bids(SearchBidRequest: $request, PaginationOptions: $pagination) {
      total
      results {
        id
        name
      }
    }
  }
`);

export function useBidsSimple(
  request: SearchBidsRequest,
  pagination: PaginationOptions,
  options?: UseQueryOptions<BidsSimpleQuery, unknown, BidsSimpleQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(
    ["bidsSimple", request, pagination],
    BIDS_QUERY,
    [{ request, pagination }],
    {
      staleTime: 1000 * 60 * 60, // 1 hour
      ...options,
    },
  );

  return {
    data: data?.bids,
    ...rest,
  };
}
